<template>
  <div class="goods_index">
    <div class="shop_top">
      <shop-top :subnav_show="false" :change_color="true"></shop-top>
    </div>
    <div class="goods_info_top_mbx width_center_1200">
      <el-breadcrumb separator=">">
        <el-breadcrumb-item :to="{ path: '/' }">{{ lang.home }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ lang.favorites }}</el-breadcrumb-item>
      </el-breadcrumb>
      <ul v-if="list.length > 0" class="action-box">
        <li v-show="isManage" @click="selectAll">
          <div class="check-box" :class="{ 'cur' : allChecked }"></div>
          {{ lang.all_select }}
        </li>
        <li v-show="isManage" @click="batchCancel">
          <svg-icon iconClass="icon_collect" />
          {{ lang.remove_favorite }}
        </li>
        <li
          @click="isManage =! isManage"
        >{{ isManage ? lang.cancel_batch_management : lang.batch_management }}</li>
        <li @click="emptyCollect">
          <svg-icon iconClass="delete" />
          {{ lang.empty_favorites }}
        </li>
      </ul>
    </div>
    <div v-loading="loading" class="goods-collect width_center_1200">
      <ul>
        <li v-for="(item, index) in list" :key="item.id">
          <div class="self-mention">
            <el-image :src="item.vemimg" lazy></el-image>
            <div class="cont">
              <div class="name">{{ item.vemName }}</div>
              <div class="address">{{ item.vemaddress }}</div>
            </div>
          </div>
          <div class="content">
            <el-image
              :src="item.productimg"
              lazy
              @click.stop="$router.push('/goods/info/'+item.productno)"
            ></el-image>
            <div class="title">{{ item.productname }}</div>
            <div class="desc">{{ item.briefName }}</div>
            <div class="price">
              {{ unit }}
              <span>{{ item.productprice.toFixed(2) }}</span>
            </div>
            <div v-show="isManage" class="manage" @click="selectGoods(index)">
              <div class="check-box" :class="{ 'cur' : item.checked }" />
              <svg-icon iconClass="collect_del" @click.stop="handleCancel(item.productno)" />
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="list.length === 0" class="empty_order">
      <dl>
        <dt>
          <img src="/images/not-common-icon.png" />
        </dt>
        <dd>{{ lang.empty_tips }}</dd>
        <dd class="btn">
          <router-link to="/">{{ lang.go_to_mall }}</router-link>
        </dd>
      </dl>
    </div>
    <shop-foot></shop-foot>
    <!-- vue 回到顶部 -->
    <el-backtop></el-backtop>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ShopTop from '@/components/ShopHead/index'
import ShopFoot from '@/components/ShopFoot/index.vue'
import { cancelColl } from '@/api/product.js'
import { getmyproductcolllist } from '@/api/user.js'
export default {
  components: {
    ShopTop,
    ShopFoot
  },
  data() {
    return {
      list: [],
      isManage: false
    }
  },
  computed: {
    lang() {
      return this.$t('goods_collect')
    },
    ...mapGetters(['unit']),
    checkNum() {
      let i = 0
      this.list.forEach((item) => {
        if (item.checked) i++
      })
      return i
    },
    allChecked: {
      get() {
        return this.checkNum === this.list.length
      },
      set() {
        let isAllSelected = this.list.every((item) => {
          return item.checked
        })
        isAllSelected ? true : false
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    emptyCollect() {
      const ids = this.list.map((item) => {
        return item.productno
      })
      this.$confirm(this.lang.clear_tips_content, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text,
        type: 'warning'
      }).then(() => {
        cancelColl(ids).then((res) => {
          if (res.code === 1) {
            this.isManage = false
            this.$message.success(res.msg)
            this.getList()
          }
        })
      })
    },
    batchCancel() {
      const ids = []
      this.list.forEach((item) => {
        if (item.checked) {
          ids.push(item.productno)
        }
      })
      this.$confirm(this.lang.remove_tips_content, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text
      }).then(() => {
        cancelColl(ids).then((res) => {
          if (res.code === 1) {
            this.isManage = false
            this.$message.success(res.msg)
            this.getList()
          }
        })
      })
    },
    handleCancel(productno) {
      this.$confirm(this.lang.remove_tips_content, this.lang.tips, {
        confirmButtonText: this.lang.confirm_text,
        cancelButtonText: this.lang.cancel_text,
        type: 'warning'
      }).then(() => {
        cancelColl([productno]).then((res) => {
          if (res.code === 1) {
            this.isManage = false
            this.$message.success(res.msg)
            this.getList()
          }
        })
      })
    },
    getList() {
      this.loading = true
      getmyproductcolllist().then(({ data }) => {
        this.list = data.map((item) => {
          return {
            checked: false,
            ...item
          }
        })
        this.loading = false
      })
    },
    selectAll() {
      if (this.allChecked) {
        this.list.forEach((item) => {
          item.checked = false
        })
        this.allChecked = false
      } else {
        this.list.forEach((item) => {
          item.checked = true
        })
        this.allChecked = true
      }
    },
    selectGoods(index) {
      this.list[index].checked = !this.list[index].checked
    }
  }
}
</script>
<style lang="scss" scoped>
.check-box {
  width: 12px;
  height: 12px;
  border: 1px solid #ec9221;
  border-radius: 50%;
  margin-right: 5px;
  &.cur {
    background: #ec9221;
  }
}
.goods_info_top_mbx {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 44px;
  /deep/ .el-breadcrumb__inner {
    font-size: 14px;
    color: #aaa !important;
    font-weight: 400 !important;
  }
  /deep/ .el-breadcrumb__separator {
    font-weight: 400;
  }
  .el-breadcrumb {
    line-height: 44px;
  }
  .action-box {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    li {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #aaa;
      margin-left: 20px;
      .svg-icon {
        margin-right: 4px;
        width: 18px;
        height: 18px;
      }
      &:hover {
        cursor: pointer;
        color: #ec9221;
      }
    }
  }
}
.goods-collect {
  padding-bottom: 50px;
  ul {
    width: 110%;
    li {
      float: left;
      margin-right: 10px;
      position: relative;
      width: 212px;
      margin-bottom: 10px;
      background: #fff;
      border-radius: 12px;
      box-shadow: 7px 7px 9px 0px #f1f4f9;
      cursor: pointer;
      .manage {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        .check-box {
          position: absolute;
          top: 15px;
          right: 15px;
        }
      }
      .content {
        padding: 10px;
      }
      .title {
        font-size: 14px;
        color: #4f4f4f;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .desc {
        font-size: 12px;
        color: #aaa;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 5px 0;
      }
      .price {
        color: #ff0000;
        font-size: 12px;
        span {
          font-size: 16px;
          font-weight: bold;
        }
      }
    }

    .self-mention {
      display: flex;
      border-bottom: 1px solid #eee;
      padding: 10px;
      .el-image {
        width: 40px;
        height: 40px;
        border-radius: 4px;
      }
      .cont {
        width: 130px;
        margin-left: 15px;
        .name {
          color: #000;
          font-size: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .address {
          color: #aaa;
          font-size: 14px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
}
.empty_order {
  margin-bottom: 100px;
}

</style>